<template>
  <div id="myElement"
       style="position: absolute; width: 100%; height: 100%; top: 0; background: #f5f5f5">
    <headers></headers>
    <!-- 移动端头部 -->
    <div class="phoneHead">
      <div class="back"
           @click="back">
        <img src="../../assets/img/phoneBack.png"
             alt="" />
      </div>
      <div @click="goStudy"
           class="goStudy">返回学习中心</div>
      <div class="texs">
        我的课程
      </div>
      <div class="back"></div>
    </div>

    <div style="display: flex;justify-content: center;background: #f5f5f5;padding-bottom: 20px;">
      <div class="consm">
        <left></left>
      <div class="banner">

        <div class="title">
          <el-button type="primary" style="border-radius: 16px;"  @click="goClass">返回我的在学班级</el-button>
        > <div style="cursor: pointer;margin-left: 5px;width: 430px;">{{ name }}的课程列表</div>
        <span style="margin-left: 10px;color: red;font-weight: bold;font-size:26px;" v-if="unlearnCourse !== 0">
          您还有{{ unlearnCourse }}门课程未完成学习
        </span>
        </div>

        <div class="courseBox">
          <div class="listBox"
               v-for="item in courseList"
               :key="item.course.id">
            <div class="leftBox">
              <div>
                <img v-if="item.course.cimage !== '' && item.course.cimage !== null"
                     class="imgBox"
                     :src="item.course.cimage"
                     @error="handleError"
                     alt="">
                <div v-else
                     class="imgBox"
                     style="position: relative;display: flex;justify-content: center;align-items: center;">
                  <img style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;;"
                       src="../../assets/img/noimg.png"
                       alt="">
                  <div style="position: relative;z-index: 11;font-size: 15px;font-family: kaiti;text-align: center;padding: 0 10px;font-weight: bold;color: #355FD9;width: 100%; height: 51px; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;">
                    {{ item.course.cname}}
                  </div>
                </div>
              </div>

              <div class="left_2">
                <div class="text_1"
                     :title="item.course.cname">
                  {{ item.course.cname }}
                </div>
                <div class="text_3">
                  总学时：{{ item.course.ccredithour }}学时
                </div>
                <div class="text_4">
                  完成学时：{{ item.course.hasCredit }}学时
                </div>
              </div>
            </div>

            <div class="centerBox">
              <div class="vis1">
                状态：{{ item.course.studyStatus == '01' ? '未学习' : item.course.studyStatus == '02' ?'学习中' :'已学习' }}
              </div>
              <div class="vis1"
                   v-if="item.course.isExam !== '01'">
                需要完成课程学习才能考试
              </div>
            </div>

            <div class="rightBox">
              <div @click="continueStudy(item.course)">
                继续学习
              </div>
            </div>
          </div>
        </div>

        <div class="pagination"
             style="display: flex;justify-content: center;">
          <pagination background
                      v-show="total > 0"
                      :total="total"
                      :page.sync="query.pageNum"
                      :limit.sync="query.pageSize"
                      @pagination="getList">
          </pagination>
        </div>
      </div>
      <right></right>
    </div>
    </div>

    <!-- 移动端 -->
    <div class="phoneBanner">
      <div class="phoneTips">
        温馨提示：需要完成课程学习才能考试
      </div>

      <div class="phoneListBox">
        <div class="courseBox"
             v-for="item in courseList"
             :key="item.course.id">
          <div class="courseContent">
            <div>
              <img :src="item.course.cimage"
                   alt="">
            </div>
            <div class="text_box">
              <div class="ff">
                {{ item.course.cname }}
              </div>
              <div class="ff1">
                要求学时：{{ item.course.ccredithour }}学时
              </div>
              <div class="ff2">
                完成学时：{{ item.course.hasCredit }}学时
              </div>
            </div>
          </div>
          <div class="btns">

            <div class="status">
              学习状态：{{ item.course.studyStatus == '01' ? '未学习' : item.course.studyStatus == '02' ?'学习中' :'已学习' }}
            </div>

            <div class="jixuBtn"
                 @click="continueStudy(item.course)">
              继续学习
            </div>
          </div>

          <div class="border">

          </div>
        </div>
        <div style="text-align: center"
             class="more"
             @click="more">
          {{ text }}
        </div>
      </div>
    </div>
    <flotRight></flotRight>
    <integral/>
    <bottom></bottom>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// Import Swiper Vue.js components
// Import Swiper styles
import headers from '@/views/component/head.vue';
import bottom from '@/views/component/bottom.vue';
import left from '@/views/component/left.vue';
import integral from '@/views/component/integral.vue'
import right from '@/views/component/right.vue';
import flotRight from '@/views/component/flotRight.vue';
import { toMyCourseList, getUrl,ylxAddOrder } from '../../api/index';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    integral,
    headers,
    bottom,
    left,
    right,
    flotRight
  },
  data() {
    // 这里存放数据
    return {
      name: '',
      classId: '',
      courseList: [], //课程列表
      query: {
        pageSize: 5,
        pageNum: 1
      },
      total: 0,
      defaultImageUrl: require('../../assets/listImgs/noimg.png'),
      text: '', //提示语
      unlearnCourse:'',//
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    handleError(event) {
      event.target.src = this.defaultImageUrl;
    },
    //跳到班级
    goClass() {
      this.$router.push({
        path: '/'
      });
    },

    goStudy() {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      getUrl().then(res => {
        console.log(res.data.data);
        if (isMobile) {
          window.location.replace(res.data.data.mobileCenterUrl + '?token=' + localStorage.getItem('token'));
        } else {
          window.location.replace(res.data.data.pcCenterUrl + '?token=' + localStorage.getItem('token'));
        }
      });
    },
    more() {
      this.query.pageNum = this.query.pageNum + 1;
      this.ylxAddOrder(this.query.orderId)
      toMyCourseList(this.query).then(res => {
        if (res.data.code == '200') {
          this.courseList.push(...res.data.list.rows);
          console.log(this.courseList);
          if (this.total <= this.query.pageSize * this.query.pageNum) {
            this.text = '';
          } else {
            this.text = '点击加载更多...';
          }
        } else {
          this.$message('请求错误,请稍后再试！');
        }
      });
    },
    back() {
      this.$router.back();
    },
    ylxAddOrder(orderId) {
      ylxAddOrder({orderId:orderId}).then(res => {
        console.log(res);
        
      })
    },
    getList() {
      this.query.classId = this.classId;
      this.query.orderId = this.orderId
      this.ylxAddOrder(this.query.orderId)
      toMyCourseList(this.query).then(res => {
        if (res.data.code == '200') {
          this.name = res.data.list.rows[0].className;
          this.courseList = res.data.list.rows;
          this.unlearnCourse = res.data.unlearnCourse
          this.total = res.data.list.total;
          if (this.total <= this.query.pageSize * this.query.pageNum) {
            this.text = '';
          } else {
            this.text = '点击加载更多...';
          }
        } else {
          this.$message('请求错误,请稍后再试！');
        }
      });
    },
    continueStudy(item) {
      console.log(item);
      this.$router.push({ path: '/fraction', query: { classId: this.classId, courseId: item.id, courseWareId: item.cwId } });
      // this.$router.push({ path: '/pattern', query: { classId: this.classId, name: item.cname, className: this.name, id: item.id } });
    }
  },
  created() {
    this.classId = this.$route.query.id;
    this.orderId = this.$route.query.orderId;
    this.getList();
  },
  destroyed() {},
  beforeDestroy() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
@media (max-width: 768px) {
  .goStudy {
    position: absolute;
    z-index: 99;
    color: #fff;
    right: 15px;
    top: 7px;
    width: 100px;
    height: 32px;
    cursor: pointer;
    font-size: 13px;
    background: #438ce7;
    text-align: center;
    line-height: 32px;
    border-radius: 32px;
  }
  .banner {
    display: none;
  }
  .more {
    font-size: 16px;
  }
  .phoneHead {
    width: 100%;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #ffffff;
    font-family: Medium;
    .back {
      width: 50px;
      img {
        width: 25px;
        height: 25px;
      }
    }
    .texs {
      font-size: 17px;
    }
  }
  .phoneBanner {
    background: #ffffff !important;
    padding-bottom: 160px;
    .phoneTips {
      height: 33px;
      background: rgba(40, 120, 255, 0.15);
      color: #2878ff;
      text-align: center;
      line-height: 33px;
      font-size: 14px;
      font-family: Medium;
    }
    .phoneListBox {
      padding: 16px;
      .courseBox {
        .courseContent {
          display: flex;
          img {
            width: 120px;
            height: 96px;
          }
          .text_box {
            color: #333333;
            margin-left: 12px;
            font-size: 15px;
            font-family: Regular;
            .ff {
              margin-top: 8px;
              font-size: 18px;
            }
            .ff1 {
              margin-top: 8px;
            }
            .ff2 {
              margin-top: 6px;
            }
          }
        }
        .btns {
          margin-top: 8px;
          display: flex;
          justify-content: space-between;
          .status {
            margin-top: 8px;
            color: #8793a4;
            font-size: 15px;
            font-family: Regular;
          }
          .jixuBtn {
            width: 96px;
            height: 37px;
            background: #2878ff;
            border-radius: 19px;
            color: #ffffff;
            font-size: 15px;
            text-align: center;
            line-height: 37px;
            font-family: Medium;
          }
        }

        .border {
          margin-top: 19px;
          margin-bottom: 19px;
          height: 1px;
          background: #eee;
        }
      }
    }
  }
}

@media (min-width: 768px) {
  .phoneHead {
    display: none;
  }
  .consm {
    width: 1400px;
    display: flex;
    background: #f5f5f5;
  }
  .phoneBanner {
    display: none;
  }
  .banner {
    width: 1000px;
    padding-top: 28px;
    position: relative;
    z-index: 1;
    background: #fff;
    .title {
      font-size: 18px;
      color: #333333;
      font-family: Bold;
      padding-left: 20px;
      display: flex;
      align-items: center;
    }
    .courseBox {
      margin-top: 12px;
      width: 1000px;
      background: #ffffff;
      padding: 8px 20px 20px 20px;
      .listBox {
        margin-top: 12px;
        width: 100%;
        height: 109px;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #eee;
        .leftBox {
          display: flex;
          .imgBox {
            width: 120px;
            height: 97px;
          }
          .left_2 {
            margin-left: 12px;
            .text_1 {
              cursor: pointer;
              margin-top: 8px;
              font-family: Bold;
              font-size: 18px;
              color: #333333;
              width:455px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .text_2 {
              margin-top: 8px;
              width: 100px;
              height: 26px;
              text-align: center;
              font-family: Medium;
              line-height: 26px;
              background: rgba(40, 120, 255, 0.1);
              color: #2878ff;
              border-radius: 2px;
              font-size: 12px;
            }
            .text_3 {
              margin-top: 12px;
              font-size: 14px;
              font-family: Medium;
              font-weight: 500;
              color: #666666;
            }
            .text_4 {
              margin-top: 5px;
              font-size: 14px;
              font-family: Medium;
              font-weight: 500;
              color: #666666;
            }
          }
        }

        .centerBox {
          width: 400px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-bottom: 15px;
          .vis1 {
            width: 100px;
            margin-top: 8px;
            font-family: Medium;
            color: #666666;
            text-align: center;
            font-size: 14px;
          }
        }

        .rightBox {
          display: flex;
          flex-direction: column;
          justify-content: center;
          div {
            width: 100px;
            height: 32px;
            border: 1px solid #2878ff;
            border-radius: 19px;
            background: #ffffff;
            border: 1px solid #2878ff;
            opacity: 1;
            cursor: pointer;
            color: #2878ff;
            font-size: 14px;
            text-align: center;
            line-height: 32px;
            font-family: Regular;
          }
        }
      }
    }
    .pagination {
      padding: 30px 0 100px 0;
    }
  }
  .more {
    font-size: 16px;
  }
}
</style>
